import React, { useState } from 'react'
import { useConflictEmployees } from 'api/hooks/use-conflict-employees'
import Table from 'react-bootstrap/Table'
import TableLoading from 'shared/tables/table-loading'
import TableFooter from 'shared/tables/table-footer'
import { InternalConflict } from 'shared/badges'

function ConflictEmployees({ conflict }) {
  const defaultParams = {
    page: 1,
    perPage: 25,
    conflict_id: conflict.id
  }

  const [params, setParams] = useState(defaultParams)

  const {
    data: employees,
    isSuccess,
    isLoading
  } = useConflictEmployees({ params })

  return (
    <>
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>User</th>
            <th>Role</th>
            <th>Conflicting Role</th>
            <th>Internal</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <TableLoading columns={4} />}
          {isSuccess &&
            employees.data.map((employee) => (
              <tr key={employee.id}>
                <td>
                  <a
                    href={`/users/${employee.id}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {employee.external_id}
                  </a>

                  <span className="ms-2 text-muted">
                    {employee.department_name}
                  </span>
                </td>
                <td>
                  <a
                    href={`/roles/${employee.role_id}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {employee.role_name}
                  </a>
                </td>
                <td>
                  <a
                    href={`/roles/${employee.conflict_role_id}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {employee.conflict_role_name}
                  </a>
                </td>
                <td>
                  {employee.is_internal ? (
                    <InternalConflict textDisplay="Internal" className="ms-1" />
                  ) : (
                    <span className="text-muted">No</span>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {isSuccess && (
        <TableFooter
          meta={employees.meta}
          params={params}
          setParams={setParams}
        />
      )}
    </>
  )
}

export default ConflictEmployees
